import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Toast: ComponentStyleConfig = {
  baseStyle: {
    container: {
      bg: 'bg.elevated',
      color: 'text.primary',
      borderWidth: '1px',
      borderColor: 'border.muted',
      boxShadow: 'elevation.2',
    },
    title: {
      color: 'text.primary',
    },
    description: {
      color: 'text.muted',
    },
    icon: {
      color: 'accent.default',
    },
  },
};
